module.exports = __webpack_public_path__ + "img/modelpicker.fdb615cd.png";